import { IHelpService } from '../interfaces/help-service.interface';

/**
 * No-Op HelpService für Apps ohne Hilfe-Feature.
 */
export class NullHelpService implements IHelpService {
	has(_key: string): boolean { return false; }
	text(_key: string): string | undefined { return undefined; }
	list(_key: string): { value: string; name: string }[] | undefined { return undefined; }
	hasList(_key: string): boolean { return false; }
	hasPicker(_key: string): boolean { return false; }
	getPickerName(_key: string): string | undefined { return undefined; }
}
